import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], filterString: any): any {

    const resultArray = [];

    if (value) {

      const properties = Object.getOwnPropertyNames(Object.values(value)[0]);
      // console.log(properties)

      if (value.length === 0 || filterString === '') {
        return value;
      }

      for (const item of value) {

        properties.forEach(property => {

          if(String(item[property]).toLocaleLowerCase().includes(filterString.toLocaleLowerCase())){
            resultArray.push(item);
          }

        });

      }
      return resultArray;
    }

  }
}
